import React from 'react';

export default function Modal({ open, onClose, title, children }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        padding: 24,
      }}
      onClick={onClose}
    >
      <div
        className="auth-card"
        style={{ maxWidth: 460, width: '100%', cursor: 'default' }}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h2 className="auth-title" style={{ fontSize: 20 }}>{title}</h2>}
        {children}
      </div>
    </div>
  );
}
